import React, { createContext, useContext, useState, useEffect } from 'react';

type LocalDateTimeContextType = {
    dateTime: Date;
};

const LocalDateTimeContext = createContext<LocalDateTimeContextType | undefined>(undefined);

export const LocalDateTimeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [dateTime, setDateTime] = useState(new Date());

    useEffect(() => {
        const dateTimer = setInterval(() => setDateTime(new Date()), 1000);
        return () => clearInterval(dateTimer);
    }, []);

    return (
        <LocalDateTimeContext.Provider value={{ dateTime }}>
            {children}
        </LocalDateTimeContext.Provider>
    );
};

export const useLocalDateTime = () => {
    const context = useContext(LocalDateTimeContext);
    if (!context) {
        throw new Error('LocalDateTime must be used within a LocalDateTimeProvider');
    }
    return context;
};
